import {createAction, createAsyncThunk} from '@reduxjs/toolkit'
import {
    filterApplyTL,
    filterApplyTA,
    filterApplyTC,
    filterApplyTP,
    filterApplyPOS,
    filterApplyDI
} from 'services/ac-strategicboard'

export const applyDataFiltersPOS = createAsyncThunk(
    'applyDataFiltersPOS',
    async (payload: any, {dispatch, rejectWithValue}) => {
        try {
            const {data} = await filterApplyPOS(payload)
            if (data?.successFlag) {
                return data?.response
            } else {
                return rejectWithValue({
                    error: {text: 'Data unavailable.', code: '500'}
                })
            }
        } catch (err: any) {
            return rejectWithValue({
                error: {
                    text: 'Data unavailable.',
                    code: '500'
                }
            })
        }
    }
)

export const applyDataFiltersTL = createAsyncThunk(
    'applyDataFiltersTL',
    async (payload: any, {dispatch, rejectWithValue}) => {
        try {
            const {data} = await filterApplyTL(payload)
            if (data?.successFlag) {
                return data?.response
            } else {
                return rejectWithValue({
                    error: {text: 'Data unavailable.', code: '500'}
                })
            }
        } catch (err: any) {
            return rejectWithValue({
                error: {
                    text: 'Data unavailable.',
                    code: '500'
                }
            })
        }
    }
)

export const applyDataFiltersTC = createAsyncThunk(
    'applyDataFiltersTC',
    async (payload: any, {dispatch, rejectWithValue}) => {
        try {
            const {data} = await filterApplyTC(payload)
            if (data?.successFlag) {
                return data?.response
            } else {
                return rejectWithValue({
                    error: {text: 'Data unavailable.', code: '500'}
                })
            }
        } catch (err: any) {
            return rejectWithValue({
                error: {
                    text: 'Data unavailable.',
                    code: '500'
                }
            })
        }
    }
)

export const applyDataFiltersTP = createAsyncThunk(
    'applyDataFiltersTP',
    async (payload: any, {dispatch, rejectWithValue}) => {
        try {
            const {data} = await filterApplyTP(payload)
            if (data?.successFlag) {
                return data?.response
            } else {
                return rejectWithValue({
                    error: {text: 'Data unavailable.', code: '500'}
                })
            }
        } catch (err: any) {
            return rejectWithValue({
                error: {
                    text: 'Data unavailable.',
                    code: '500'
                }
            })
        }
    }
)

export const applyDataFiltersTA = createAsyncThunk(
    'applyDataFiltersTA',
    async (payload: any, {dispatch, rejectWithValue}) => {
        try {
            const {data} = await filterApplyTA(payload)
            if (data?.successFlag) {
                return data?.response
            } else {
                return rejectWithValue({
                    error: {text: 'Data unavailable.', code: '500'}
                })
            }
        } catch (err: any) {
            return rejectWithValue({
                error: {
                    text: 'Data unavailable.',
                    code: '500'
                }
            })
        }
    }
)

export const applyDataFiltersDI = createAsyncThunk(
    'applyDataFiltersDI',
    async (payload: any, {dispatch, rejectWithValue}) => {
        try {
            const {data} = await filterApplyDI(payload)
            if (data?.successFlag) {
                return data?.response
            } else {
                return rejectWithValue({
                    error: {text: 'Data unavailable.', code: '500'}
                })
            }
        } catch (err: any) {
            return rejectWithValue({
                error: {
                    text: 'Data unavailable.',
                    code: '500'
                }
            })
        }
    }
)

export const acPayload = createAction<object>('common/payload')
